import { getValueByNs } from './utils';
import { log } from './console.js';

/**
 * Save JSON stringified value to storage (`localStorage` by default)
 * @param {string} key
 * @param {StorageValue} value
 * @param {Storage} [storage=localStorage]
 */
export function saveValueToStorage(key, value, storage = window.localStorage) {
  storage.setItem(key, JSON.stringify(value));
}

/**
 * Try to get value from storage (`localStorage` by default) as JSON parsed value
 * @param {string} key
 * @param {Object} params
 * @param {Storage} [params.storage=localStorage] Object with Storage interface
 * @param {*} [params.defaultValue]
 * @param {string} [params.namespace] Property path to get value from
 * @returns {StorageValue | undefined}
 */
export function getValueFromStorage(
  key,
  { storage = window.localStorage, defaultValue, namespace } = {},
) {
  const rawValue = storage.getItem(key);

  if (!rawValue) {
    return defaultValue;
  }

  let value;

  try {
    value = JSON.parse(rawValue);
  } catch (e) {
    log.error(`Unable to parse value ${rawValue}`);
    return defaultValue;
  }

  if (namespace) {
    return getValueByNs(value, namespace, defaultValue);
  }

  return value;
}
